import { useEffect, useState } from "react";

import Modal from "../Util/Modal";

type DecisionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  decision: { id: string; name: string };
  onSubmit: (decision: { id: string; name: string }) => void;
};

export default function DecisionModal({ isOpen, onClose, decision, onSubmit }: DecisionModalProps) {
  const [name, setName] = useState(decision.name);

  useEffect(() => {
    setName(decision.name);
  }, [decision]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`${decision.id === "" ? "Add" : "Edit"} Decision`}>
      <>
        <form className="my-5 grid gap-5 md:grid-cols-4 items-center">
          <label className="text-xs font-medium">Name</label>
          <input type="text" className="form-input col-span-3 rounded-sm border border-gray-200 text-xs" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
        </form>
        <div className="mt-4 flex justify-end -m-6 px-6 bg-gray-50 py-5 border-t">
          <button
            type="button"
            className="form-input inline-flex items-center border border-transparent leading-4 font-medium shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-sm px-4 text-sm py-2 bg-green-400 hover:bg-green-500 focus:ring-green-500"
            onClick={() => {
              onSubmit({ ...decision, name });
            }}
          >
            Save
          </button>
          <button
            type="button"
            className="ml-3 inline-flex items-center border leading-4 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded-sm px-4 text-sm py-2 bg-white hover:bg-gray-50 text-current border-gray-200"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </>
    </Modal>
  );
}
